import { getOrganizationInterest } from 'utils/authService'

export const getDialogVisibleState = () => {
  return localStorage.getItem('helpCenterModalVisible') !== 'false'
}

export const setDialogVisibleState = value => {
  localStorage.setItem('helpCenterModalVisible', value)
}

export const getActivePage = () => {
  const activePage = getOrganizationInterest()

  switch (activePage) {
    case 'TRACKING':
      return 'multipleBids'
    case 'EXPEDITE':
      return 'proposalCreation'
    default:
      return 'steps'
  }
}
